import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import './SongList.scss';
import SongCard from '../SongCard/SongCard';
import SkeletonCard from '../SkeletonCard/SkeletonCard';
import {setSelectedSong, setIsAssignToContactFlow, showToast, setPopUp, PopUpEnum, setDefaultSong, getSubscribersData} from '../../FuntoneSlice';
import {useScreenNavigation} from '../../Utils/ScreenNavigationUtils';

const SongList = ({
  songs = [],
  onSongClick = () => {},
  onPlayClick = () => {},
  onDownloadClick = () => {},
  className = '',
  currentPlayingSongId = null,
  isLoading = false,
  skeletonCount = 6,
  skeletonVariant = 'song',
}) => {
  const dispatch = useDispatch();
  const {navigateToSongSettings} = useScreenNavigation();
  const selectedSubscriber = useSelector((state) => state.FuntoneSlice.selectedSubscriber);

  // Show skeletons while loading
  if (isLoading) {
    return (
      <div className={`song-list ${className} loading`}>
        {Array.from({length: skeletonCount}, (_, index) => (
          <div key={`skeleton-${index}`} className='song-list-item'>
            <SkeletonCard variant={skeletonVariant} />
          </div>
        ))}
      </div>
    );
  }

  if (!songs || songs.length === 0) {
    return (
      <div className={`song-list ${className} empty`}>
        <p className='empty-message'>לא נמצאו שירים</p>
      </div>
    );
  }

  const handleSongClick = (song, index) => {
    onSongClick(song, index);
  };

  const handlePlayClick = (e, song) => {
    e.stopPropagation();
    onPlayClick(song);
  };

  const handleDownloadClick = (e, song) => {
    e.stopPropagation();
    onDownloadClick(song);
  };

  const isPlaying = (songId) => {
    return currentPlayingSongId === songId;
  };

  const createMenuActionsWithHandlers = (song) => {
    if (!song.menuActions) return [];

    return song.menuActions.map((action) => ({
      ...action,
      onClick: async (e) => {
        switch (action.key) {
          case 'assign-to-contact':
            dispatch(setSelectedSong(song));
            dispatch(setIsAssignToContactFlow(true));
            navigateToSongSettings();
            break;
          case 'set-as-default':
            const productId = song.productId || song.id;
            await dispatch(
              setDefaultSong({
                subscriber: selectedSubscriber?.cli,
                productId: productId,
              }),
            );
            break;
          case 'delete-song':
            dispatch(setSelectedSong(song));
            dispatch(setPopUp({type: PopUpEnum.DELETE_SONG}));
            break;
          default:
            console.log('Unknown action', action.key);
        }
      },
    }));
  };

  return (
    <div className={`song-list ${className}`}>
      {songs.map((song, index) => (
        <div
          key={song.id || song.productId || index}
          className={`song-list-item ${isPlaying(song.id || song.productId) ? 'playing' : ''}`}
          onClick={() => handleSongClick(song, index)}>
          <SongCard
            song={{
              id: song.id || song.productId,
              description: song.description || song.title,
              author: song.author || song.artist || song.artistName,
              duration: song.duration,
              image: song.image || song.albumArt,
              isDownloadable: song.isDownloadable,
              isPlayable: song.isPlayable,
              isPlaying: isPlaying(song.id || song.productId),
              funtonPrevUrl: song.funtonPrevUrl,
            }}
            onPlayClick={(e) => handlePlayClick(e, song)}
            onDownloadClick={(e) => handleDownloadClick(e, song)}
            showMenu={!!song.menuActions}
            menuActions={createMenuActionsWithHandlers(song)}
          />
        </div>
      ))}
    </div>
  );
};

export default SongList;
